import { render, staticRenderFns } from "./RegulatoryInfoChemicalBiologicalTab.vue?vue&type=template&id=5e1934a7&"
import script from "./RegulatoryInfoChemicalBiologicalTab.vue?vue&type=script&lang=js&"
export * from "./RegulatoryInfoChemicalBiologicalTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports